import WindowScrollHelper from '@/ui-kit/helpers/WindowScrollHelper';
import { MapBoundsProperty, MapProperty } from '@/components/maps/enums';
import { DEFAULT_MAP_CONFIG } from '../constants';
import CheckFilterValues from './CheckFilterValues';
import FetchSoldData from './FetchSoldData';
import ApiQueryMapper from '../mappers/ApiQueryMapper';

const HandleMap = {
  data() {
    return {
      mapConfig: DEFAULT_MAP_CONFIG,
    };
  },
  mixins: [FetchSoldData, CheckFilterValues],
  methods: {
    scrollToListingMap() {
      WindowScrollHelper.scrollIntoView(this.$refs.map.$el);
    },
    setMapBounds(bounds) {
      const areBoundsValid = Object.values(MapBoundsProperty).every((boundKey) => bounds[boundKey]);

      if (areBoundsValid) {
        this.mapConfig[MapProperty.Bounds] = { ...bounds };
      }
    },
    handleMapPositionChange(newPositionData) {
      if (this.justContentLoaded) {
        this.justContentLoaded = false;

        return;
      }

      if (
        newPositionData?.bounds
        && !this.contentLoading
        && this.checkFiltersValues(this.$route.query)
      ) {
        this.loadSoldDataByMapBounds(newPositionData.bounds);
      }
    },
    loadSoldDataByMapBounds(bounds) {
      const northEast = bounds.getNorthEast();
      const southWest = bounds.getSouthWest();
      const requestQuery = ApiQueryMapper.mapFilterToQuery({
        ...this.$route.query,
        [MapBoundsProperty.MinLat]: southWest.lat(),
        [MapBoundsProperty.MinLon]: southWest.lng(),
        [MapBoundsProperty.MaxLat]: northEast.lat(),
        [MapBoundsProperty.MaxLon]: northEast.lng(),
      });

      this.loadSoldData(requestQuery);
    },
  },
};

export default HandleMap;
